import {Theme, useFundamentalContext} from '@hm/fundamental'
import {useEffect} from 'react'

const HPRODUCE_THEME_LIGHT: Theme = 'ThemeLightBlue'

export const FundamentalThemeInitializer = () => {
  const {theme: fundamental} = useFundamentalContext()

  useEffect(() => {
    if (fundamental.currentTheme !== HPRODUCE_THEME_LIGHT) {
      fundamental.updateTheme(HPRODUCE_THEME_LIGHT)
    }
  }, [fundamental])

  return null
}
